import { render, staticRenderFns } from "./TopShelf.vue?vue&type=template&id=f067b270&"
import script from "./TopShelf.vue?vue&type=script&lang=js&"
export * from "./TopShelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports